import { api } from '@/shared'
import { message } from 'antd'
import { equipmentContractActions } from '@/entity/regulatoryInformation/contract/index'
import { downloadFileByUid } from '@/shared/api/rest/pension/downloadFileByUid'
import { getSpoList as getSpoListApi } from '@/shared/api/rest/external/spo'
import { equipment1Actions } from '@/entity'

export const getDownloadFile = (payload) => {
	const { data, onSuccess, onError } = payload

	return async (dispatch) => {
		try {
			dispatch(equipmentContractActions.getDownloadFileAction())

			const res = await downloadFileByUid(data)

			if (res) {
				dispatch(equipmentContractActions.getDownloadFileActionDone(res))
				onSuccess(res)
			}
		} catch (error) {
			message.error(error.response?.data?.message)

			dispatch(equipmentContractActions.getDownloadFileActionFail())
		}
	}
}

export const deleteData = (payload) => {
	const { data, onSuccess, onError } = payload

	return async (dispatch) => {
		try {
			dispatch(equipmentContractActions.deleteDataAction())

			const res = await api.regulatoryInformation.contract.deleteDoc(data)

			dispatch(equipmentContractActions.deleteDataActionDone(res))
			onSuccess()
		} catch (error) {
			message.error(error.response?.data?.message)

			dispatch(equipmentContractActions.deleteDataActionFail())
		}
	}
}

export const setXml = (payload) => {
	const { data, onSuccess, onError } = payload

	return async (dispatch) => {
		try {
			dispatch(equipmentContractActions.setXmlAction())

			const res = await api.regulatoryInformation.contract.xml(data)

			if (res) {
				dispatch(equipmentContractActions.setXmlActionDone(res))
				onSuccess(res)
			}
		} catch (error) {
			message.error(error.response?.data?.message)

			dispatch(equipmentContractActions.setXmlActionFail())
		}
	}
}

export const setXmlSend = (payload) => {
	const { data, onSuccess, onError } = payload

	return async (dispatch) => {
		try {
			dispatch(equipment1Actions.setXmlSendAction())

			const res = await api.regulatoryInformation.contract.send(data)

			dispatch(equipment1Actions.setXmlSendActionDone(res))
			if (onSuccess) {
				onSuccess(res)
			}
		} catch (error) {
			message.error(error.response?.data?.message)

			dispatch(equipment1Actions.setXmlSendActionFail())
			if (onError) {
				onError(error)
			}
		}
	}
}

export const getSpoList = (payload = {}) => {
	const { onSuccess, onError } = payload

	return async (dispatch) => {
		try {
			dispatch(equipmentContractActions.getSpoListAction())

			const res = await getSpoListApi()

			if (res) {
				dispatch(equipmentContractActions.getSpoListActionDone(res.data || []))
				if (onSuccess) onSuccess(res.data || [])
			}
		} catch (error) {
			message.error(error.response?.data?.message)

			dispatch(equipmentContractActions.getSpoListActionFail())
			if (onError) onError(error)
		}
	}
}
